/// <reference path="~/js/global.js"/>
/// <reference path="~/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>
/// <reference path="~/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="~/js/viz/bar/config/Config.js"/>
/// <reference path="~/js/viz/shared/models/SelectorsModel.js"/>

(function(Backbone, _) {
  "use strict";

  var ns, config;

  ns = window.nspace("ccc.viz.bar.views");
  config = window.ccc.viz.bar.config.Config;

  ns.BarView = Backbone.View.extend({
    /**
     * These magic numbers are seeds to calculate the correct height of the bar chart div.
     * We calculate by assuming a certain amount of fixed overhead for the axes, then
     * assume a variable number of bars.
     */
    singleBarBaseHeight: 76,
    multiBarBaseHeight: 76,
    additionalBarHeight: 25,
    additionalMultiBarGroup: 29,

    /**
     * Since the SVG rectangle will go into navigation mode if the container div is too small to contain it,
     * we have to calculate the height of the legend and adjust the height accordingly.
     */

    /**
     * A fixed amount of padding overhead for each legend.
     */
    legendOverhead: 33,
    /**
     * The height of an individual legend span with the current font settings.
     */
    legendItemHeight: 18,

    initialize: function(options) {
      _.bindAll(this);

      this.selectorsModel = options.selectorsModel;

      this.model.on("change", this.render);

      $(window).on("scroll", this.updateLegendPosition);
    },

    render: function() {
      var options;

      if (!this.selectorsModel.areModelArraysValid()) {
        return;
      }

      options = $.extend(
        true,
        {},
        config.defaultHighchartsConfig,
        this.model.get("response").highCharts
      );
      this.formatYAxisLabels(options);
      this.adjustForSingleCharacteristic(options);
      this.sizeBarChartContainer(options);
      options.series = options.series.reverse();
      options.colors = options.colors.reverse();
      this.orderChartColors(options);

      this.$(".bar-chart").highcharts(options);

      this.updateLegendPosition();
    },

    /**
     * Adjust the highcharts options for single characteristic charts. The bar config file defaults to multi-bar settings.
     */
    adjustForSingleCharacteristic: function(options) {
      var singleCharacteristicConfig;

      if (this.isMultiBarChart()) {
        return;
      }

      singleCharacteristicConfig =
        window.ccc.viz.bar.config.SingleCharacteristicConfig;
      $.extend(true, options, singleCharacteristicConfig);
    },

    /**
     * Adds a formatter, where necessary, for the yAxis labels.
     */
    formatYAxisLabels: function(options) {
      if (
        !(options.tooltip || {}).valuePrefix &&
        !(options.tooltip || {}).valueSuffix
      ) {
        return;
      }

      window.createNestedObject(options, ["yAxis", "labels", "formatter"]);

      options.yAxis.labels.formatter = function() {
        var newValue = this.value;
        if (options.tooltip.valueSuffix === "%") {
          newValue = Math.round(this.value * 10000) / 100;
        }
        else if (options.tooltip.valuePrefix === "$") {
          if (this.value >= 1000) {
            newValue = Math.round(this.value / 100) / 10 + "k";
          }
          else {
            newValue = this.value;
          }
        }
        return (
          (options.tooltip.valuePrefix || "") +
          newValue +
          (options.tooltip.valueSuffix || "")
        );
      };
    },

    /**
     * Updates the position of the legend relative to the window scroll position.
     */
    updateLegendPosition: function() {
      var $container,
        $legend,
        $rect,
        isIE8,
        $svg,
        svgOffset,
        windowScrollTop,
        newY,
        containerOffset,
        containerHeight,
        legendHeight,
        legendTranslation;

      $container = this.$(".highcharts-container");
      $legend = this.$(".highcharts-legend");
      $rect = $legend.find("rect").first();
      isIE8 = $rect.length === 0; // IE8 condition

      windowScrollTop = $(window).scrollTop();
      containerHeight = $container.height();

      if (isIE8) {
        containerOffset = $container.offset();
        if (!containerOffset) {
          return;
        }
        newY = windowScrollTop - containerOffset.top;

        legendHeight = 22; // height of initial margin
        // get the height of all the spans and add them
        $legend.find("span").each(function() {
          legendHeight += $(this).height();
        });

        if (newY > containerHeight - legendHeight) {
          return;
        }
        else if (newY > 10) {
          // scrolled past the top
          $legend.css("top", newY + "px");
        }
        else {
          $legend.css("top", "0px");
        }

        return;
      }

      $svg = $legend.closest("svg");
      svgOffset = $svg.offset();

      if (!svgOffset || $legend.length === 0) {
        return;
      }

      newY = windowScrollTop - svgOffset.top + 10;
      legendHeight = +$rect.attr("height");
      legendTranslation = $legend.attr("transform");
      if (!legendTranslation) {
        return;
      }
      else if (newY >= containerHeight - legendHeight) {
        return;
      }
      else if (newY > 10 && newY < containerHeight - legendHeight) {
        $legend.attr(
          "transform",
          legendTranslation.replace(
            /(translate\(\d*[, ])\d*(\))/gi,
            "$1" + newY + "$2"
          )
        );
      }
      else {
        $legend.attr(
          "transform",
          legendTranslation.replace(
            /(translate\(\d*[, ])\d*(\))/gi,
            "$1" + 10 + "$2"
          )
        );
      }
    },

    sizeBarChartContainer: function(options) {
      var height;

      height = this.calculateCorrectBarHeight();
      height = this.adjustForLegendHeight(height, options);
      this.$(".bar-chart").height(height);
    },

    /**
     * Highcharts doesn't try to find an ideal bar chart size. It tries to squeeze everything into the container size that you set, or if you don't set the size explicitly,
     * it doesn't go past a certain fixed height. So the point of this method is to get a good chart size that works for all charts.
     */
    calculateCorrectBarHeight: function() {
      if (this.isMultiBarChart()) {
        return this.calculateMultiBarHeight();
      }
      return this.calculateSingleBarHeight();
    },

    /**
     * Gets the optimal multi-bar chart height.
     */
    calculateMultiBarHeight: function() {
      var locationCount, characteristicCount, height;

      locationCount = this.selectorsModel.get("locationIds").length;
      characteristicCount = this.selectorsModel.get("characteristicIds").length;

      // We use locationCount - 1 because the initial bar group heights are already assumed in the base height.
      // We use characteristicCount - 2 because the initial individual bar heights already assume there are two characteristics per group.
      height =
        this.multiBarBaseHeight + // The height of a single bar multi bar chart.
        (locationCount - 1) * this.additionalMultiBarGroup + // Gets the overhead associated with all additional location groups.
        (characteristicCount - 1) *
          Math.max(locationCount, 1) *
          this.additionalBarHeight; // Gets the size of extra characteristics for each new group, including the original location group;

      return height;
    },

    /**
     * Gets the optimal single-bar chart height.
     */
    calculateSingleBarHeight: function() {
      var locationCount, height;

      locationCount = this.selectorsModel.get("locationIds").length;

      // We use locationCount - 1 as a multiplier because the initial bar height is already assumed in the base height.
      height =
        this.singleBarBaseHeight +
        (locationCount - 1) * this.additionalBarHeight;

      return height;
    },

    /**
     * Determines whether we're dealing with a single or multi bar chart.
     */
    isMultiBarChart: function() {
      var characteristicIds;

      characteristicIds = this.selectorsModel.get("characteristicIds");
      if (characteristicIds && characteristicIds[0] !== "a") {
        return true;
      }

      return false;
    },

    /**
     * Ordering the colors so that regardless of the number of series in the chart, we return a consistent ordering of colors.
     */
    orderChartColors: function(options) {
      if (!options || !options.colors || !options.series) {
        return;
      }

      options.colors = _.map(options.colors, function(color, index) {
        var arrayLength, arrayDiff;

        arrayLength = options.colors.length;
        arrayDiff = options.series.length - options.colors.length;
        return index + (arrayLength - arrayDiff) < options.colors.length
          ? options.colors[index + (arrayLength - arrayDiff)]
          : options.colors[index - arrayDiff];
      });
    },

    /**
     * Adjusts the height of the div container based on the legend size.
     * @param height The current height of the container div.
     */
    adjustForLegendHeight: function(height, options) {
      var self, maxLegendSize, legendLines, actualLegendSize;

      // Return the original height if there's no legend.
      if (options.legend.enabled === false) {
        return height;
      }

      self = this;
      legendLines = 0;
      maxLegendSize = height - this.legendOverhead;
      _.each(this.selectorsModel.get("characteristicIds"), function(id) {
        var indicatorId, name, modifiedName;

        legendLines++;
        indicatorId = self.selectorsModel.get("indicatorId");
        name = _.filter(
          self.selectorsModel.selectorInfo.selectors[indicatorId]
            .characteristics,
          function(characteristic) {
            return +characteristic.id === +id;
          }
        )[0].name;

        modifiedName = config.defaultHighchartsConfig.legend.labelFormatterHelper(
          name
        );
        // Uses jQuery to find the number of br elements in the modified name text. Any *real* performance issues here?
        legendLines = legendLines + $(modifiedName).filter("br").length;
      });

      actualLegendSize = legendLines * this.legendItemHeight;
      if (maxLegendSize - actualLegendSize >= 0) {
        return height;
      }

      return height + actualLegendSize - maxLegendSize;
    }
  });
})(Backbone, _);
